import { createReducer, on } from "@ngrx/store";
import { loadEmployeeByIdAct } from "./employee.actions";
import { Role } from "../../models/rol";
import { Employee } from "../../models/employee";

//const employees: Employee[] = [];
const employee: Employee = new Employee();
const roles: Role[] = [];

export const employeeReducer = createReducer(
    {
        //employees,
        //paginator: {},
        employee,
        violations: {},
        loading: true,
        roles
    },
    
    /*on(findAllPageableEmployeeAct, (state, { employees, paginator }) => ({
        employees: [...employees],
        paginator: {... paginator},
        employee: state.employee,
        violations: state.violations,
        loading: false,
        roles: state.roles
    }
    )),*/
    
    on(loadEmployeeByIdAct, (state, { employee }) => ({
        //employees: state.employees,
        //paginator: state.paginator,
        employee: { ...employee }, //state.users.find(user => user.id == id) || new User(),
        violations: state.violations,
        loading: false,
        roles: state.roles
    }))
    
);